/*
    Action.js - Action model
 */

import {Rest} from '@/paks/vu-app'

export default new Rest('Action', {
    invoke: {method: 'POST', uri: '/:controller/invoke'},
})
